import { axiosInstance } from './axiosInstance';
import axios from 'axios';



export const list = async (db) => {
    try {
        const response = await axiosInstance.get('/api/v1/adminpanel/group/list');
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const getUserByGID = async (ID) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/group/${ID}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
}

export const addGroup = async (data, id = "") => {
    try {
        let response;
        if (id) {
            response = await axiosInstance.put(`/api/v1/adminpanel/group/edit/${id}`, data);
        } else {
            response = await axiosInstance.post(`/api/v1/adminpanel/group/add`, data);
        }

        return response;
    } catch (error) {
        return error;
    }
}

export const deleteGroupByID = async (ID) => {
    try {
        const response = await axiosInstance.delete(`/api/v1/adminpanel/group/delete/${ID}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

